import { gql } from '__generated__';

export default gql(`
  query GetPurchaseDetails($project_id: ID!, $purchase_id: ID!) {
    project(id: $project_id) {
      id
      purchase(id: $purchase_id) {
        id
        amount
        balance
        revenue
        refunded_amount
        refundable_amount
        remaining_amount
        invoice_amount
        active
        batch_size
        unit_id
        ticket_number
        ticket_number_digits
        ticket_number_locked
        ticket_number_sequence {
          id
          corral_name
          start_time
        }
        ticket {
          id
          title
          units
        }
        product {
          id
          title
        }
        promotion {
          id
          title
          standard
          amount
        }
        product_variant {
          id
          title
        }
        time_slot {
          id
          title
          start_date
          start_time
          multi_date
        }
        coupon_code {
          id
          value
          coupon {
            id
          }
        }
        invitation_code {
          id
          value
          invitation {
            id
          }
        }
        participant {
          id
          full_name
          email
        }
        registration {
          id
          sequence
          assigned
          full_name
          invited_email
          created_at
        }
        order {
          id
          invoice_id
          amount
          credited_amount
          remaining_amount
          is_open
          participant {
            id
            email
            full_name
            balance
          }
        }
        refund_options {
          payment {
            id
            payment_method
            status_changed_at
            amount
            refundable_amount
            consumer_account
            created_at
          }
          items {
            amount
          }
        }
      }
    }
  }
`);
